module.exports = __webpack_public_path__ + "img/banner2@1x (1).51b0cab5.png";